var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.833332C6.75626 0.833332 7.16667 1.24374 7.16667 1.75V2.66667H10.8333V1.75C10.8333 1.24374 11.2437 0.833332 11.75 0.833332C12.2563 0.833332 12.6667 1.24374 12.6667 1.75V2.66667H15.4167C16.4292 2.66667 17.25 3.48748 17.25 4.5V16.4167C17.25 17.4292 16.4292 18.25 15.4167 18.25H2.58333C1.57081 18.25 0.75 17.4292 0.75 16.4167V4.5C0.75 3.48748 1.57081 2.66667 2.58333 2.66667H5.33333V1.75C5.33333 1.24374 5.74374 0.833332 6.25 0.833332ZM5.33333 4.5H2.58333V7.25H15.4167V4.5H12.6667V5.41667C12.6667 5.92293 12.2563 6.33333 11.75 6.33333C11.2437 6.33333 10.8333 5.92293 10.8333 5.41667V4.5H7.16667V5.41667C7.16667 5.92293 6.75626 6.33333 6.25 6.33333C5.74374 6.33333 5.33333 5.92293 5.33333 5.41667V4.5ZM15.4167 9.08333H2.58333V16.4167H15.4167V9.08333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.90fb13aac2d2c7cc2f33c2e712927bf0.svg";
export { ForwardRef as ReactComponent };